<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="" name=''>
      <a-select v-model:value="search.action" :style="{width:'180px'}" placeholder="请选择">
        <a-select-option value="">全部账单</a-select-option>
        <a-select-option :value="1">入账</a-select-option>
        <a-select-option :value="2">出账</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='type' :columns='columns' :data-source='data'>
    <template v-slot:point="{ record }">
      <span>{{record.action == 1 ? '+':'-'}}{{record.point}}</span>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getAssetsPointBill } from "@/api/reimbursement";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 5,
    store_id:'',
    action:'',
  };
  export default {
    name: "lookPoint",
    components: {},
    props: {
      id:{
        type:Number
      }
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      const search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        total: 1,
        time:[]
      });
      let columns = [
        {
          title: "积分来源/去向",
          dataIndex: "type",
          key: "type",
        },
        {
          title: "积分数量",
          dataIndex: "point",
          key: "point",
          slots: { customRender: "point" }
        },
        {
          title: "日期",
          dataIndex: "create_time",
          key: "create_time",
        }
      ];
      const $router = inject('$router')

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getAssetsPointBill({...values,store_id:props.id}).then(res => res.data).catch(error=>error);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        
      };
    },
  };
</script>
